import {Assessment} from "@mui/icons-material"
import React from "react"
import {useReportUrlFilters} from "../../../hooks/useReportUrlFilters"
import {ReportSubPaths} from "../../../../ReportSubPaths"
import {AvantColors} from "../../../../../../styles/AvantColors"
import {groupMasterStore} from "../../../../../common/group/GroupMasterStore"
import {useHistory} from "react-router"
import {PLACE_PRODUCT_ID} from "../../../../../../util/Constants"
import {findPLACEIndividualReport} from "../../../../PlaceFamily/PLACEReportPage"
import Tooltip from "@mui/material/Tooltip"

export const IndividualReportLink = ({takeId, productId, classGroupId}: {
    takeId: number,
    productId: number,
    classGroupId: number
}) => {
    const filters = useReportUrlFilters()
    const history = useHistory()

    const additionalReportData = async (): Promise<string | Object> => {
        switch (productId) {
            case PLACE_PRODUCT_ID.value():
                return JSON.parse(findPLACEIndividualReport(takeId))
            default:
                const groupInfo = await groupMasterStore.findGroupInfo(classGroupId)
                return JSON.stringify(groupInfo)
        }
    }

    const handleClick = async () => {
        try {
            history.push({
                pathname: ReportSubPaths.individual(takeId, {...filters, productId: productId}),
                state: {report: await additionalReportData()}
            })
        } catch (error) {
            console.error("Failed to fetch group info:", error)
        }
    }

    return (
        <Tooltip title={"Individual Report"}>
            <Assessment sx={{color: AvantColors.avantDarkGrey, cursor: "pointer"}} onClick={handleClick}/>
        </Tooltip>
    )
}